import React from "react";
import Button from "./Button";

const SubscriptionCard = ({
  title,
  name,
  type,
  price = 0,
  description,
  buttonText,
  buttonIcon,
  period,
  onClick,
  cardStyle,
  buttonStyle,
  hover,
  glow,
}) => {
  const price_str = price?.toString().includes('.')? price?.toString().replace('.','').padStart(4, "0") :price?.toString().padStart(4, "0");
  const price_str_length = price_str.length;
  const left_side_price = price_str.slice(0, price_str_length - 2);
  const right_side_price = price_str.slice(
    price_str_length - 2 - price_str_length
  );

  return (
    <div className={`card ${hover && "card-hover"}`} style={cardStyle || {}}>
      {title && <p className="card-title">{title}</p>}
      <div className="card-detail-container">
        {type && (
          <div className="type-container">
            <p className="type-text">{type?.toUpperCase()}</p>
          </div>
        )}

        <p className="card-text-name">{name}</p>

        <div className="card-price-container">
          <p className="card-text-price">
            {"$" +
              (left_side_price[0] == "0"
                ? left_side_price.replace()
                : left_side_price) +
              "." +
              right_side_price}
          </p>
          <p
            className="card-text-period"
            style={{ marginLeft: 5, marginRight: 5 }}
          >
            {"/"}
          </p>
          <div className="card-text-period">{period}</div>
        </div>

        <div className="card-description-container">
          <p className="card-description-text">{description}</p>
        </div>

        {onClick && (
          <Button
            buttonIcon={buttonIcon}
            buttonStyle={buttonStyle}
            onClick={onClick}
            buttonText={buttonText}
            glow={glow}
          />
        )}
      </div>
    </div>
  );
};
export default SubscriptionCard;
